import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { ResetPasswordValidationService } from '../../service/reset-password-validation.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  @ViewChild('ReInput') ReInput!: ElementRef;
  @ViewChild('passwordInput') passwordInput!: ElementRef;
  

  NewPassword = '';
  RePassword = '';
  token: string = '';
  showFrom = false;
  showPage = false;
  userName = '';
  userId = NaN;
  isValid: boolean = false;
  submitClicked = false;
  uppercaseMatch: boolean = false;
  lengthCheck: boolean = false;
  specialCharMatch: boolean = false;
  numberMatch: boolean = false;
  validationMssgArr: string[] = []
  validationMssg = '';
  nameOfUser = '';
  password1Class = 'show-password'
  password2Class = 'show-password'


  constructor(
    private router: ActivatedRoute,
    private router2: Router,
    private toasterandLoader: ToasterService,
    private resetService: ResetPasswordValidationService
  ) { }

  ngOnInit() {
    this.toasterandLoader.isLoaderEnable(true);
    localStorage.clear();
    this.token = <any>this.router.snapshot.queryParamMap.get('token');
    if (!this.token) {
      this.toasterandLoader.isLoaderEnable(false);
    } else {
      this.tokenCheck();
    }

  }

  tokenCheck() {
    this.resetService.checkToken({ token: this.token }).subscribe({
      next: (res) => {
        if (res?.data?.validation) {
          this.toasterandLoader.isLoaderEnable(false);
          this.showPage = true;
          this.userId = res.data?.userId;
          this.userName = res.data?.userName;
          this.nameOfUser = res.data?.name;
        } else {
          this.toasterandLoader.isLoaderEnable(false);
          this.showPage = false;

        }
      },
      error: (err) => {
        this.toasterandLoader.isLoaderEnable(false);
        this.showPage = false;
      }
    })
  }

  validatePassword() {
    const uppercaseRegex = /[A-Z]/g;
    const numberRegex = /[0-9]/g;
    const specialCharRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
    this.validationMssgArr = []
    this.uppercaseMatch = this.NewPassword.match(uppercaseRegex)?.length ? true : false;
    this.numberMatch = this.NewPassword.match(numberRegex)?.length ? true : false;
    this.specialCharMatch = this.NewPassword.match(specialCharRegex)?.length ? true : false;
    this.lengthCheck = this.NewPassword.length >= 8;
    if (!this.uppercaseMatch) {
      this.validationMssgArr.push('Atleast one Upper case include in password');
    }
    if (!this.numberMatch) {
      this.validationMssgArr.push('Atleast one number include in password');
    }
    if (!this.specialCharMatch) {
      this.validationMssgArr.push(`Atleast one Special(!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?) charecter include in password`);
    }
    if (!this.lengthCheck) {
      this.validationMssgArr.push('Minimum password contain 8 charecters!!');
    }
    this.isValid = this.uppercaseMatch && this.numberMatch && this.specialCharMatch && this.lengthCheck
    this.validationMssg = this.isValid? '' : this.validationMssgArr.join(' / ');
    // return this.isValid
  }

  restSubmited() {
    this.submitClicked = true;
    if (this.isValid && this.NewPassword && this.RePassword && this.NewPassword === this.RePassword) {
      this.toasterandLoader.isLoaderEnable(true);
      let payload = {
        newPassword: this.NewPassword,
        confirmPassword: this.RePassword
      }

      this.resetService.resetPassword(payload, this.userId).subscribe({
        next: (value) => {
          this.router2.navigate(['login/user-login']);
          this.toasterandLoader.isLoaderEnable(false);
          this.toasterandLoader.alert.toast({
            title: 'Success',
            type: 'success',
            message: 'User Successfully Updated',
          });
        },
        error: (err) => {
          this.toasterandLoader.alert.toast({
            title: 'Error',
            type: 'error',
            message: err.message,
          });
            this.toasterandLoader.isLoaderEnable(false);
        },
      })
    }
  }

  showPassword(val:boolean){
    if(val){
      this.passwordInput.nativeElement.setAttribute("type", this.passwordInput.nativeElement.getAttribute("type") === "password"? "text" : "password");
      this.password1Class = this.passwordInput.nativeElement.getAttribute("type") === "password" ? 'show-password' : 'hide-password'
    }else{
      this.ReInput.nativeElement.setAttribute("type", this.ReInput.nativeElement.getAttribute("type") === "password"? "text" : "password");
      this.password2Class = this.ReInput.nativeElement.getAttribute("type") === "password" ? 'show-password' : 'hide-password'
    }
    
  }


}
